import cn from 'classnames';

import { EColorMap } from '../constants/colorMap';
import { IConDefaultType } from '../types';

export interface IPlusIconProps extends IConDefaultType {}

function PlusIcon({ color, className, size = 24, rotate, flip }: IPlusIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.9607 3.60014C12.9607 3.06994 12.5309 2.64014 12.0007 2.64014C11.4705 2.64014 11.0407 3.06994 11.0407 3.60014V11.0401H3.60063C3.07043 11.0401 2.64062 11.4699 2.64062 12.0001C2.64062 12.5303 3.07043 12.9601 3.60063 12.9601H11.0407V20.4001C11.0407 20.9303 11.4705 21.3601 12.0007 21.3601C12.5309 21.3601 12.9607 20.9303 12.9607 20.4001V12.9601H20.4006C20.9308 12.9601 21.3606 12.5303 21.3606 12.0001C21.3606 11.4699 20.9308 11.0401 20.4006 11.0401H12.9607V3.60014Z"
          fill={color || EColorMap.gray_0}
        />
      </svg>
    </i>
  );
}

export default PlusIcon;
